export default __webpack_public_path__ + "static/media/ic_wif_40.2f6472c1.png";